import { render, staticRenderFns } from "./MarketplaceProvidersFilteredViewAll.vue?vue&type=template&id=65c00af0&scoped=true"
import script from "./MarketplaceProvidersFilteredViewAll.vue?vue&type=script&lang=js"
export * from "./MarketplaceProvidersFilteredViewAll.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceProvidersFilteredViewAll.vue?vue&type=style&index=0&id=65c00af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c00af0",
  null
  
)

export default component.exports